import {
  CUSTOMER_PORTAL_THEME,
  LAST_PAGE,
  LOGIN_TIME,
  SESSION_TIME,
  SELECTED_COMPANIES_IDS,
  SELECTED_TASK_TYPES,
  USER_TOKEN,
  USER_PERMISSIONS,
  DUMONT_TOKEN_KEY,
} from "../constants";

const deleteAllTokens = (params: { shouldReload?: boolean } = {}) => {
  const { shouldReload = true } = params;
  localStorage.removeItem("user_company");
  localStorage.removeItem(USER_TOKEN);
  localStorage.removeItem(USER_PERMISSIONS);
  localStorage.removeItem("current_user");
  localStorage.removeItem("user");
  localStorage.removeItem("user_uid");
  localStorage.removeItem(CUSTOMER_PORTAL_THEME);
  localStorage.removeItem(LOGIN_TIME);
  localStorage.removeItem(LAST_PAGE);
  localStorage.removeItem(SESSION_TIME);
  localStorage.removeItem(SELECTED_COMPANIES_IDS);
  localStorage.removeItem(SELECTED_TASK_TYPES);
  sessionStorage.removeItem(DUMONT_TOKEN_KEY);
  if (shouldReload) location.reload();
};

export default deleteAllTokens;
